<template>
	<div>
		<k-modal
			id="updateVersionModal"
			:title="$t('modals.updateVersion.title')"
			okVariant="info"
			size="402px"
			class="d-block"
			@ok="emitOk"
			:okTitle="modalOkBtnText"
			:okOnly="true"
			no-close-on-backdrop
			:no-close-on-esc="true"
		>
			<template v-slot:content>
				<k-crud :fields="versionUpdatetructure" ref="KCrudUpdateVersionModal" />
			</template>
		</k-modal>
	</div>
</template>

<script>
import KModal from "./KModal.vue";
import KCrud from "../ui/KCrud.vue";

export default {
	components: {
		KModal,
		KCrud
	},

	methods: {
		emitOk: function () {
			this.$router.push({
				name: "Login"
			});
		}
	},

	computed: {
		modalOkBtnText: function () {
			let modalOkBtn = this.$t("buttons.ok");
			return modalOkBtn;
		},
		versionUpdatetructure: function () {
			let structure = [
				{
					rowNum: 0,
					width: "12",
					label: this.$t("modals.updateVersion.message"),
					enterPress: () => {
						this.emitOk();
					}
				}
			];
			return structure;
		}
	}
};
</script>

<style>
#updateVersionModal header button {
	visibility: hidden;
}
</style>
